export const PROJECT_ROUTE_PATH = '/project';

export enum PROJECT_STATE {
  COMPLETED = 'Completed',
  IN_PROGRESS = 'Progress',
  NOT_STARTED = 'NotStarted',
}

export const PROJECT_CREATE_ROUTE_PATH =
  `${PROJECT_ROUTE_PATH}/create` as const;
